import React from "react";
import { Modal } from "react-bootstrap";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import CategoryPopupBody from "./CategoryPopupBody";
import Close from "../../../Helpers/CloseBtn/Close";

export default function CategoryPopup({ id, onClose, title, data }) {
  const defaultImage =
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png";

  return (
    <Popup show={!!id}>
      {/* {isLoading && (
        <div className="loader-container">
          <Loader />
        </div>
      )} */}
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            driverimg={data.picture || defaultImage}
            headtitle={title}
          />
        </Modal.Title>
        <Close
          // eslint-disable-next-line react/style-prop-object
          style="close-32 close"
          close={() => onClose()}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <CategoryPopupBody data={data} />
      </Modal.Body>
    </Popup>
  );
}
